// extracted by mini-css-extract-plugin
module.exports = {"searchResult":"ArchiveTargetSearchItem_searchResult__2NwBP","wrapper":"ArchiveTargetSearchItem_wrapper__26ZKc"};